import { Img } from "react-image";
import { Loader2 } from "lucide-react";
import { clsx } from "clsx";

/**
 * 图片组件
 * @param props
 * @constructor
 */
export function Image({
  className,
  src,
  alt,
  onClick,
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  return (
    <Img
      className={className}
      src={src ?? ""}
      alt={alt || "Image"}
      loader={
        <div className={clsx(className, "flex items-center justify-center")}>
          <Loader2 className={"animate-spin"} />
        </div>
      }
      unloader={<div className={clsx(className, "w-full rounded-lg bg-gray-100")}></div>}
      onClick={onClick}
    />
  );
}
